import { SplitPanel } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedSplitPanel } from "./widget";
export const SplitPanelInternal = createWidgetizedSplitPanel(SplitPanel);
